import { TOGGLE_SOUND, CHANGE_THEME, SET_NOTIFICATION } from '../actions/setting-actions-types';

const initialState = {
  sound: true,
  themeType: 'light',
  notification: {
    all: true,
    smart: true
  },
  isDashboardTourGuideActive: false
};

export default function setting(state = initialState, action: { type: any; payload: any }) {
  switch (action.type) {
    case TOGGLE_SOUND:
      return {
        ...state,
        sound: !state.sound
      };
    case CHANGE_THEME: {
      return {
        ...state,
        themeType: action.payload
      };
    }
    case SET_NOTIFICATION:
      return {
        ...state,
        notification: action.payload
      };
    default:
      return state;
  }
}
